(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mellura-favorites"] && !Shopify.designMode) return;
  try {
    
  class MelluraFavoritesPage {
    constructor(root) {
      this.root = root;
      this.grid = root.querySelector('[data-favorites-grid]');
      this.empty = root.querySelector('[data-favorites-empty]');
      this.summary = root.querySelector('[data-favorites-summary]');
      this.template = root.querySelector('[data-favorite-card-template]');
      this.render();
      window.addEventListener('mellura:favorites:changed', () => this.render());
    }

    getFavorites() {
      try {
        const favorites = JSON.parse(localStorage.getItem('mellura:favorites:v1') || '[]');
        return Array.isArray(favorites) ? favorites : [];
      } catch {
        return [];
      }
    }

    removeFavorite(productId) {
      const favorites = this.getFavorites().filter((favorite) => String(favorite.id) !== String(productId));
      localStorage.setItem('mellura:favorites:v1', JSON.stringify(favorites));
      window.dispatchEvent(new CustomEvent('mellura:favorites:changed', { detail: { favorites } }));
    }

    createCard(favorite) {
      const card = this.template.content.firstElementChild.cloneNode(true);
      const titleParts = String(favorite.title || '').split(' · ');
      const name = titleParts[0] || favorite.title || '';
      const subtitle = titleParts.length > 1 ? titleParts.slice(1).join(' · ') : '';
      const url = favorite.url || `/products/${favorite.handle}`;
      const mediaLink = card.querySelector('[data-favorite-link]');
      const titleLink = card.querySelector('[data-favorite-title-link]');
      const image = card.querySelector('[data-favorite-image]');

      mediaLink.href = url;
      titleLink.href = url;
      titleLink.textContent = name;
      card.querySelector('[data-favorite-subtitle]').textContent = subtitle;
      card.querySelector('[data-favorite-price]').textContent = favorite.price || '';
      image.src = favorite.image || '';
      image.alt = favorite.title || name;
      card.querySelector('[data-remove-favorite]').addEventListener('click', () => this.removeFavorite(favorite.id));
      return card;
    }

    render() {
      const favorites = this.getFavorites();
      this.grid.replaceChildren();
      favorites.forEach((favorite) => this.grid.appendChild(this.createCard(favorite)));
      const hasFavorites = favorites.length > 0;
      this.grid.hidden = !hasFavorites;
      this.empty.hidden = hasFavorites;
      this.summary.hidden = false;
      this.summary.textContent = `${favorites.length} ${favorites.length === 1 ? 'favoriet' : 'favorieten'}`;
    }
  }

  document.querySelectorAll('[data-mellura-favorites]').forEach((root) => {
    if (!root.dataset.melluraFavoritesInitialized) {
      root.dataset.melluraFavoritesInitialized = 'true';
      new MelluraFavoritesPage(root);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mellura-product-page"] && !Shopify.designMode) return;
  try {
    
  class MelluraProductPage {
    constructor(root) {
      this.root = root;
      this.media = [...root.querySelectorAll('[data-media-id]')];
      this.thumbnails = [...root.querySelectorAll('[data-media-target]')];
      this.currentMediaIndex = Math.max(0, this.media.findIndex((item) => !item.hidden));
      this.bindGallery();
      this.bindVariants();
      this.bindQuantity();
      this.bindFavorite();
    }

    showMedia(id) {
      const nextIndex = this.media.findIndex((item) => item.dataset.mediaId === String(id));
      if (nextIndex < 0) return;
      this.currentMediaIndex = nextIndex;
      this.media.forEach((item, index) => {
        const active = index === nextIndex;
        item.hidden = !active;
        item.classList.toggle('is-active', active);
      });
      this.thumbnails.forEach((button) => {
        const active = button.dataset.mediaTarget === String(id);
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', String(active));
      });
    }

    stepGallery(direction) {
      if (!this.media.length) return;
      const next = (this.currentMediaIndex + direction + this.media.length) % this.media.length;
      this.showMedia(this.media[next].dataset.mediaId);
    }

    bindGallery() {
      this.thumbnails.forEach((button) => {
        button.addEventListener('click', () => this.showMedia(button.dataset.mediaTarget));
      });
      this.root.querySelector('[data-gallery-previous]')?.addEventListener('click', () => this.stepGallery(-1));
      this.root.querySelector('[data-gallery-next]')?.addEventListener('click', () => this.stepGallery(1));
    }

    bindVariants() {
      const radios = [...this.root.querySelectorAll('input[name^="mellura-variant-"]')];
      const hiddenVariant = this.root.querySelector('[data-variant-id]');
      const price = this.root.querySelector('[data-selected-price]');
      const selectedTitle = this.root.querySelector('[data-selected-variant]');
      const specificationTitle = this.root.querySelector('[data-specification-variant]');
      const addButton = this.root.querySelector('[data-add-to-cart]');
      const klarna = this.root.querySelector('[data-klarna-installments]');
      const klarnaInfo = this.root.querySelector('[data-klarna-info]');
      const klarnaDetails = this.root.querySelector('[data-klarna-details]');

      const updateKlarna = (priceInCents) => {
        if (!klarna) return;
        const price = Number(priceInCents);
        klarna.hidden = !price || price < 3500;
        if (klarnaDetails) klarnaDetails.hidden = true;
        if (klarnaInfo) klarnaInfo.setAttribute('aria-expanded', 'false');
        if (!price || price < 3500) return;
        const installment = Math.round(price / 3);
        const formattedInstallment = new Intl.NumberFormat('nl-NL', {
          style: 'currency',
          currency: klarna.dataset.klarnaCurrency || 'EUR'
        }).format(installment / 100);
        klarna.dataset.klarnaPriceCents = priceInCents;
        klarna.querySelector('[data-klarna-installment]').textContent = formattedInstallment;
      };

      updateKlarna(klarna?.dataset.klarnaPriceCents);

      klarnaInfo?.addEventListener('click', () => {
        if (!klarnaDetails) return;
        klarnaDetails.hidden = !klarnaDetails.hidden;
        klarnaInfo.setAttribute('aria-expanded', String(!klarnaDetails.hidden));
      });

      radios.forEach((radio) => {
        radio.addEventListener('change', () => {
          if (!radio.checked) return;
          if (hiddenVariant) hiddenVariant.value = radio.value;
          if (price) price.textContent = radio.dataset.variantPrice || '';
          updateKlarna(radio.dataset.variantPriceCents);
          if (selectedTitle) selectedTitle.textContent = radio.dataset.variantTitle || '';
          if (specificationTitle) specificationTitle.textContent = radio.dataset.variantTitle || '';

          const available = radio.dataset.variantAvailable === 'true';
          if (addButton) {
            addButton.disabled = !available;
            addButton.textContent = available ? addButton.dataset.addLabel : addButton.dataset.soldOutLabel;
          }

          if (radio.dataset.variantMediaId) this.showMedia(radio.dataset.variantMediaId);

          const url = new URL(window.location.href);
          url.searchParams.set('variant', radio.value);
          window.history.replaceState({}, '', url);
        });
      });
    }

    bindQuantity() {
      const input = this.root.querySelector('input[name="quantity"]');
      if (!input) return;
      this.root.querySelector('[data-quantity-minus]')?.addEventListener('click', () => input.stepDown());
      this.root.querySelector('[data-quantity-plus]')?.addEventListener('click', () => input.stepUp());
    }

    getFavorites() {
      try {
        const favorites = JSON.parse(localStorage.getItem('mellura:favorites:v1') || '[]');
        return Array.isArray(favorites) ? favorites : [];
      } catch {
        return [];
      }
    }

    setFavoriteState(button, isFavorite) {
      const label = isFavorite ? button.dataset.removeLabel : button.dataset.addLabel;
      button.setAttribute('aria-pressed', String(isFavorite));
      button.setAttribute('aria-label', label);
      button.title = label;
    }

    bindFavorite() {
      const button = this.root.querySelector('[data-favorite-toggle]');
      if (!button) return;

      const productId = String(button.dataset.productId);
      const updateState = () => {
        const isFavorite = this.getFavorites().some((favorite) => String(favorite.id) === productId);
        this.setFavoriteState(button, isFavorite);
      };

      updateState();
      button.addEventListener('click', () => {
        const favorites = this.getFavorites();
        const favoriteIndex = favorites.findIndex((favorite) => String(favorite.id) === productId);

        if (favoriteIndex >= 0) {
          favorites.splice(favoriteIndex, 1);
        } else {
          favorites.push({
            id: productId,
            handle: button.dataset.productHandle,
            url: button.dataset.productUrl,
            title: button.dataset.productTitle,
            price: button.dataset.productPrice,
            image: button.dataset.productImage
          });
        }

        try {
          localStorage.setItem('mellura:favorites:v1', JSON.stringify(favorites));
        } catch {
          return;
        }

        updateState();
        window.dispatchEvent(new CustomEvent('mellura:favorites:changed', { detail: { favorites } }));
      });
    }
  }

  document.querySelectorAll('[data-mellura-product]').forEach((root) => {
    if (!root.dataset.melluraInitialized) {
      root.dataset.melluraInitialized = 'true';
      new MelluraProductPage(root);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mellura-product-recommendations"] && !Shopify.designMode) return;
  try {
    
  class MelluraProductRecommendations extends HTMLElement {
    connectedCallback() {
      if (!this.dataset.url || this.dataset.loaded) return;
      const observer = new IntersectionObserver((entries) => {
        if (!entries[0].isIntersecting) return;
        observer.disconnect();
        this.loadRecommendations();
      }, { rootMargin: '0px 0px 300px 0px' });
      observer.observe(this);
    }

    async loadRecommendations() {
      this.dataset.loaded = 'true';
      try {
        const response = await fetch(this.dataset.url);
        if (!response.ok) return;
        const html = document.createElement('div');
        html.innerHTML = await response.text();
        const rendered = html.querySelector(`mellura-product-recommendations[data-section-id="${this.dataset.sectionId}"]`);
        if (!rendered || !rendered.innerHTML.trim()) return;
        this.innerHTML = rendered.innerHTML;
      } catch (error) {
        return;
      }
    }
  }

  if (!customElements.get('mellura-product-recommendations')) {
    customElements.define('mellura-product-recommendations', MelluraProductRecommendations);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mellura-size-guide"]) return;
  try {
    
  (() => {
    const initialize = (root) => {
      if (root.dataset.sizeGuideReady === 'true') return;
      root.dataset.sizeGuideReady = 'true';

      const visual = root.querySelector('[data-size-visual]');
      const image = root.querySelector('.mellura-size-guide__image');
      const title = root.querySelector('[data-size-title]');
      const copy = root.querySelector('[data-size-copy]');
      const shopLink = root.querySelector('[data-size-shop-link]');
      const counter = root.querySelector('[data-size-counter]');
      const tabs = [...root.querySelectorAll('[data-size-key]')];

      if (!visual || !image || !title || !copy || !shopLink || !counter || tabs.length === 0) return;

      const selectSize = (tab) => {
        if (!tab) return;

        tabs.forEach((item) => {
          item.setAttribute('aria-selected', String(item === tab));
        });

        const update = () => {
          visual.classList.add('is-changing');
          window.setTimeout(() => {
            image.removeAttribute('srcset');
            image.removeAttribute('sizes');
            image.src = tab.dataset.sizeImage;
            image.alt = tab.dataset.sizeAlt;
            title.textContent = tab.dataset.sizeTitle;
            copy.textContent = tab.dataset.sizeCopy;
            shopLink.href = tab.dataset.sizeLink;
            shopLink.textContent = tab.dataset.sizeButton;
            counter.textContent = String(tabs.indexOf(tab) + 1) + ' / ' + String(tabs.length);
            visual.classList.remove('is-changing');
          }, 150);
        };

        if (document.startViewTransition) {
          document.startViewTransition(update);
        } else {
          update();
        }
      };

      tabs.forEach((tab) => {
        tab.addEventListener('click', () => selectSize(tab));
        tab.addEventListener('keydown', (event) => {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          const direction = event.key === 'ArrowRight' ? 1 : -1;
          const currentIndex = tabs.indexOf(tab);
          const nextTab = tabs[(currentIndex + direction + tabs.length) % tabs.length];
          nextTab.focus();
          selectSize(nextTab);
        });
      });
    };

    const initializeAll = (scope = document) => {
      scope.querySelectorAll('[data-mellura-size-guide]').forEach(initialize);
    };

    initializeAll();
    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
